import { getPlatformPathname } from '../platform'

export const getPublicAssetSrc = (src: string) => getPlatformPathname(src)
